export const INITIAL_VALUES = {
  groupAt: null,
  groupFor: null,
  date_start: '',
  date_finish: '',
  isTransfered: 0,
};
